import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MainContent from './LandingPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MainContent />
    );

